// extracted by mini-css-extract-plugin
module.exports = {"item":"select-drugs_item__1YZ5f","itemTitle":"select-drugs_itemTitle__Yt7nX"};